import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { RuntimeService } from './shared/services/runtime.service';
import { AuthService } from './auth/services/auth.service';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { interceptorInterceptor } from '../interceptors/interceptor.interceptor';
import { errorHandlerInterceptor } from '../interceptors/error-handler.interceptor';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxPanZoomModule } from 'ngx-panzoom';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { TabRouteReuseStrategy } from './layout/tab-route-reuse.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(async () => inject(RuntimeService)),
    provideAppInitializer(() => inject(AuthService).resumeRevalidationIfNeeded()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideHttpClient(withInterceptors([interceptorInterceptor, errorHandlerInterceptor])),
    {
      provide: RouteReuseStrategy,
      useClass: TabRouteReuseStrategy,
    },
    importProvidersFrom([
      BrowserModule,
      BrowserAnimationsModule,
      NgxPanZoomModule,
      ModalModule.forRoot(),
      TimepickerModule.forRoot(),
      PopoverModule.forRoot(),
      ToastrModule.forRoot({
        positionClass: "toast-top-right",
        timeOut: 3000,
        preventDuplicates: true,
      }),
      DragDropModule,
      NgxSpinnerModule.forRoot(),
      OverlayModule,
      PortalModule,
    ]),
  ],
};
